import { NgModule } from '@angular/core';
import { CART_IMPORT_EXPORT_FEATURE, ImportExportRootModule } from "@spartacus/cart/import-export/root";
import { CmsConfig, provideConfig } from "@spartacus/core";

@NgModule({
  declarations: [],
  imports: [
    ImportExportRootModule
  ],
  providers: [provideConfig(<CmsConfig>{
    featureModules: {
      [CART_IMPORT_EXPORT_FEATURE]: {
        module: () =>
          import('@spartacus/cart/import-export').then((m) => m.ImportExportModule),
      },
    }
  }),
  ]
})
export class CartImportExportFeatureModule { }
